/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const TAB = 'TAB';
export const CREATE_REBATE_ERROR_MSG = 'CREATE_REBATE_ERROR_MSG';
export const CREATE_FIELD_ERR = 'CREATE_FIELD_ERR';
export const CREATE_REBATE_PGM_DETAIL = 'CREATE_REBATE_PGM_DETAIL';
export const COPY_CREATE_REBATE_PGM_DETAIL = 'COPY_CREATE_REBATE_PGM_DETAIL';
export const CR_DEFAULT_AUDIT = 'CR_DEFAULT_AUDIT';
export const CR_ENABLE_SAVE = 'CR_ENABLE_SAVE';
export const COMMENTS_FLAG = 'COMMENTS_FLAG';
export const COPY_DATA = 'COPY_DATA';
export const CLEAR_CREATE_RBT_REDUX = 'CLEAR_CREATE_RBT_REDUX';
export const CR_URA_GRID_DATA = 'CR_URA_GRID_DATA';
export const COPY_URA_GRID_DATA = 'COPY_URA_GRID_DATA';
export const CR_DELETED_URA_SOURCE = 'CR_DELETED_URA_SOURCE';
export const CR_DELETED_URA_CALC = 'CR_DELETED_URA_CALC';
export const CR_DELETED_URA_PAY = 'CR_DELETED_URA_PAY';
export const CR_LAST_FROZEN_QTR = 'CR_LAST_FROZEN_QTR';
export const CR_LAST_URA_SRC_CALC_QTR = 'CR_LAST_URA_SRC_CALC_QTR';

export const CR_INT_GRID_DATA = 'CR_INT_GRID_DATA';
export const CR_COPY_INT_GRID_DATA = 'CR_COPY_INT_GRID_DATA';
export const CR_DELETED_INT_CALC = 'CR_DELETED_INT_CALC';
export const CR_DELETED_INT_FED = 'CR_DELETED_INT_FED';
export const CR_DELETED_INT_FED_FMLY = 'CR_DELETED_INT_FED_FMLY';

export const CR_GROUP_GRID_DATA = 'CR_GROUP_GRID_DATA';
export const CR_COPY_GROUP_GRID_DATA = 'CR_COPY_GROUP_GRID_DATA';
export const CR_DELETED_CMS_RPT = 'CR_DELETED_CME_RPT';
export const CR_DELETED_CMS_UTIL = 'CR_DELETED_CMS_UTIL';

export const CR_ENROLL_GRID_DATA = 'CR_ENROLL_GRID_DATA';
export const CR_COPY_ENROLL_GRID_DATA = 'CR_COPY_ENROLL_GRID_DATA';
export const CR_MAX_ENROLL_QTR = 'CR_MAX_ENROLL_QTR';

export const CR_DELETED_ENROLL = 'CR_DELETED_ENROLL';

export const CR_CONS_AUDIT_DATA = 'CR_CONS_AUDIT_DATA';
export const CR_AUDIT_GRID_DATA = 'CR_AUDIT_GRID_DATA';
export const CR_COPY_AUDIT_GRID_DATA = 'CR_COPY_AUDIT_GRID_DATA';

export const CR_COPY_UNIT_TYPE_DATA = 'CR_COPY_UNIT_TYPE_DATA';
export const CR_UNIT_TYPE_AUDIT_GRID_DATA = 'CR_UNIT_TYPE_AUDIT_GRID_DATA';

export const CR_COMMENTS_FLAG = 'CR_COMMENTS_FLAG';

export const CR_USE_DEF_AUDIT = 'CR_USE_DEF_AUDIT';

export const CR_CMS_FREEZE_QTR = 'CR_CMS_FREEZE_QTR';

export const CREATED_FLAG = 'CREATED_FLAG';
export const RESET_CREATE_PGM = 'RESET_CREATE_PGM';
export const CUSTOME_RESET_CREATE_PGM = 'CUSTOME_RESET_CREATE_PGM';

export const CR_DEFAULT_OVERRIDE_DATA = 'CR_DEFAULT_OVERRIDE_DATA';

export const IS_VALID_REBETE_PGM = 'IS_VALID_REBETE_PGM';

export const CR_COPY_URA_GRID_DATA = 'CR_COPY_URA_GRID_DATA';
